import { Box } from "@mui/material";
import MxImageBlur, { BlurredBackgroundImageProps } from "@rf-l1/images/MxImageBlur";

interface MxDetailCardAgentPictureProps extends BlurredBackgroundImageProps {}
const MxDetailCardAgentPicture = (props: MxDetailCardAgentPictureProps) => {
  return (
    <Box width={60} height={60}>
      <MxImageBlur {...props} width={60} height={60} borderRadius={100} />
    </Box>
  );
};

export default MxDetailCardAgentPicture;
